"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("./react");

var useRaf = function useRaf() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e12;
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _react_1$useState = react_1.useState(0),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      elapsed = _react_1$useState2[0],
      set = _react_1$useState2[1];

  react_1.useEffect(function () {
    var raf, timerStop, start;

    var onFrame = function onFrame() {
      var time = Math.min(1, (Date.now() - start) / ms);
      set(time);
      loop();
    };

    var loop = function loop() {
      raf = requestAnimationFrame(onFrame);
    };

    var onStart = function onStart() {
      timerStop = setTimeout(function () {
        cancelAnimationFrame(raf);
        set(1);
      }, ms);
      start = Date.now();
      loop();
    };

    var timerDelay = setTimeout(onStart, delay);
    return function () {
      clearTimeout(timerStop);
      clearTimeout(timerDelay);
      cancelAnimationFrame(raf);
    };
  }, [ms, delay]);
  return elapsed;
};

exports.default = useRaf;